module.exports = __webpack_public_path__ + "static/media/stack-diamonds.71255ded.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/stack-diamonds.svg
// module id = 3567
// module chunks = 7